import React from "react";
import "../style/AccountModal.scss";

const AccountModal = ({ user, onClose, onLogout }) => {
  if (!user) return null;

  // Генерация инициалов
  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0]?.toUpperCase())
      .slice(0, 2)
      .join("");
  };

  return (
    <div className="account-modal-overlay" onClick={onClose}>
      <div className="account-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="title">Аккаунт</h3>

        <div className="avatar">{getInitials(user.name)}</div>

        <h4 className="name">{user.name}</h4>
        <p className="role">{user.role || "Пользователь"}</p>

        <button className="logout-btn" onClick={onLogout}>
          Выйти из аккаунта
        </button>
      </div>
    </div>
  );
};

export default AccountModal;
